import { render, staticRenderFns } from "./creatorManagement.vue?vue&type=template&id=4484fe78&scoped=true&"
import script from "./creatorManagement.vue?vue&type=script&lang=js&"
export * from "./creatorManagement.vue?vue&type=script&lang=js&"
import style0 from "./creatorManagement.vue?vue&type=style&index=0&id=4484fe78&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484fe78",
  null
  
)

export default component.exports